// extracted by mini-css-extract-plugin
export var lg = "_ee-7";
export var md = "_ee-6";
export var placeholderContainer = "_ee-1";
export var placeholderIcon = "_ee-2";
export var productImage = "_ee-0";
export var sm = "_ee-5";
export var xl = "_ee-8";
export var xs = "_ee-4";
export var xxs = "_ee-3";